/* eslint-disable */

var simpleBars = []

jQuery(document).ready(function ($) {
  window.init2();
});

var pSuccess = null;
var pFailure = null;
var pAuth = null;
var pReg = null;
var pOrder = null;
var pOrderNoReg = null;
var pFilterCatalog = null;
var selectLocationHeader = null;
var selectLocationHeaderFixed = null;
var selectLocationHeaderMobile = null;
var selectLocationOrder = null;
var selectLocationOrderMobile = null;
var selectLocationBasket = null;
var selectLocationBasketMobile = null;

window.init2 = function() {
  var catalogListItems = $(".catalog-detail-list-item a");
  var catalogTilesItems = $(".catalog-detail-tiles-item a");
  var profileMoreItems = $(".profile-buys-item .profile-more__btn");
  var catalogDetailCategoryItems = $(".catalog-detail-category-item__title a");

  // Oplata tabs
  $('.oplata_section__tabs .item').off('click');
  $('.oplata_section__tabs .item').on('click', function () {
    $('.oplata_section__tabs_content').removeClass('_show');

    var id = $(this).data('tab');
    $('.oplata_section__tabs .item._active').removeClass('_active');
    $(this).addClass('_active');
    $('.oplata_section__tabs_content.tab' + id).addClass('_show');
  });

  catalogListItems.each(function () {
    $(this).off( "mouseenter mouseleave" );
    $(this).hover(function () {
      $(this).parent().parent().toggleClass('_hover');
    })
  })

  catalogDetailCategoryItems.each(function () {
    $(this).off( "mouseenter mouseleave" );
    $(this).hover(function () {
      $(this).parent().parent().toggleClass('_hover');
    })
  })

  profileMoreItems.each(function () {
    $(this).off( "mouseenter mouseleave" );
    $(this).hover(function () {
      $(this).parent().parent().toggleClass('_hover');
    })
  })

  catalogTilesItems.each(function () {
    $(this).off( "mouseenter mouseleave" );
    $(this).hover(function () {
      $(this).parent().parent().parent().toggleClass('_hover');
    })
  });

  simpleBars.forEach((item) => {
    item.unMount();
  });

  $('._custom-scroll').each(function (index, item) {
    simpleBars.push(new SimpleBar(item, {
      autoHide: false
    }))
  });

  if (pSuccess !== null) {
    pSuccess.destroy();
  }
  pSuccess = new jBox('Modal', {
    content: $('.p-success').clone(),
    adjustDistance: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    isolateScroll: false,
    closeButton: false
  });

  if (pFailure !== null) {
    pFailure.destroy();
  }
  pFailure = new jBox('Modal', {
    content: $('.p-failure').clone(),
    adjustDistance: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    isolateScroll: false,
    closeButton: false
  });

  if (pAuth !== null) {
    pAuth.destroy();
  }
  pAuth = new jBox('Modal', {
    content: $('.p-auth').clone(),
    adjustDistance: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    isolateScroll: false,
    closeButton: false
  });

  if (pReg !== null) {
    pReg.destroy();
  }
  pReg = new jBox('Modal', {
    content: $('.p-reg').clone(),
    adjustDistance: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    isolateScroll: false,
    closeButton: false
  });

  if (pOrder !== null) {
    pOrder.destroy();
  }
  pOrder = new jBox('Modal', {
    content: $('.p-order').clone(),
    adjustDistance: {
      top: 0,
      right: 0,
      left: 0
    },
    isolateScroll: false,
    closeButton: false
  });

  if (pOrderNoReg !== null) {
    pOrderNoReg.destroy();
  }
  pOrderNoReg = new jBox('Modal', {
    content: $('.p-order-no-reg').clone(),
    adjustDistance: {
      top: 0,
      right: 0,
      left: 0
    },
    isolateScroll: false,
    closeButton: false
  });

  if (pFilterCatalog !== null) {
    pFilterCatalog.destroy();
  }
  pFilterCatalog = new jBox('Modal', {
    content: $('.catalog-detail-filter-block._mobile').clone(),
    adjustDistance: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    isolateScroll: false,
    width: '100%',
    closeButton: false
  });

  if (selectLocationHeader !== null) {
    selectLocationHeader.destroy();
  }
  selectLocationHeader = new jBox('tooltip', {
    content: $('.header #h-select-location').clone(),
    attach: '.select-location-header',
    trigger: 'click',
    adjustTracker: true,
    closeOnClick: 'body',
    closeOnEsc: true,
    animation: 'move',
    isolateScroll: false,
    position: {
      x: 'center',
      y: 'top'
    },
    outside: 'x',
    offset: {
      y: 30
    },
    onCreated: () => {
      $('#h-select-location .h-select-location-btn').off('click');
      $('#h-select-location .h-select-location-btn').on('click', function () {
        selectLocationHeader.close();
      });
    },
    onOpen: () => {
      simpleBars.forEach((item) => {
        item.unMount();
      })

      simpleBars = [];

      setTimeout(() => {
        $('._custom-scroll').each((index, item) => {
          simpleBars.push(new SimpleBar(item, {
            autoHide: false
          }))
        })
      }, 200);
    }
  });

  if (selectLocationHeaderFixed !== null) {
    selectLocationHeaderFixed.destroy();
  }
  selectLocationHeaderFixed = new jBox('tooltip', {
    content: $('.header #h-select-location').clone(),
    attach: '.select-location-header-fixed',
    trigger: 'click',
    adjustTracker: true,
    closeOnClick: 'body',
    closeOnEsc: true,
    animation: 'move',
    isolateScroll: false,
    fixed: true,
    position: {
      x: 'center',
      y: 'top'
    },
    outside: 'x',
    offset: {
      y: 30
    },
    onCreated: function () {
      $('#h-select-location .h-select-location-btn').off('click');
      $('#h-select-location .h-select-location-btn').on('click', function () {
        selectLocationHeaderFixed.close();
      });
    },
    onOpen: () => {
      simpleBars.forEach((item) => {
        item.unMount();
      })

      simpleBars = [];

      setTimeout(() => {
        $('._custom-scroll').each((index, item) => {
          simpleBars.push(new SimpleBar(item, {
            autoHide: false
          }))
        })
      }, 200);
    }
  });

  if (selectLocationHeaderMobile !== null) {
    selectLocationHeaderMobile.destroy();
  }
  selectLocationHeaderMobile = new jBox('tooltip', {
    content: $('.header #h-select-location').clone(),
    attach: '.select-location-header-mobile',
    trigger: 'click',
    adjustTracker: true,
    closeOnClick: 'body',
    closeOnEsc: true,
    animation: 'move',
    isolateScroll: false,
    position: {
      x: 'center',
      y: 'top'
    },
    outside: 'x',
    offset: {
      y: 44
    },
    onCreated: function () {
      $('#h-select-location .h-select-location-btn').off('click');
      $('#h-select-location .h-select-location-btn').on('click', function () {
        selectLocationHeaderMobile.close();
      })

      if ($(window).width() < 420) {
        this.options.offset = {
          x: 40,
          y: 44
        }
      }
    },
    onOpen: () => {
      simpleBars.forEach((item) => {
        item.unMount();
      })

      simpleBars = [];

      setTimeout(() => {
        $('._custom-scroll').each((index, item) => {
          simpleBars.push(new SimpleBar(item, {
            autoHide: false
          }))
        })
      }, 200);
    }
  });

  if (selectLocationOrder !== null) {
    selectLocationOrder.destroy();
  }
  selectLocationOrder = new jBox('tooltip', {
    content: $('.header #h-select-location').clone(),
    attach: '#select-location-order',
    trigger: 'click',
    adjustTracker: true,
    closeOnClick: 'body',
    closeOnEsc: true,
    animation: 'move',
    isolateScroll: false,
    position: {
      x: 'center',
      y: 'top'
    },
    outside: 'x',
    offset: {
      y: 44
    },
    onCreated: function () {
      $('#h-select-location .h-select-location-btn').off('click');
      $('#h-select-location .h-select-location-btn').on('click', function () {
        selectLocationOrder.close();
      })
    },
    onOpen: () => {
      simpleBars.forEach((item) => {
        item.unMount();
      })

      simpleBars = [];

      setTimeout(() => {
        $('._custom-scroll').each((index, item) => {
          simpleBars.push(new SimpleBar(item, {
            autoHide: false
          }))
        })
      }, 200);
    }
  });

  if (selectLocationOrderMobile !== null) {
    selectLocationOrderMobile.destroy();
  }
  selectLocationOrderMobile = new jBox('tooltip', {
    content: $('.header #h-select-location').clone(),
    attach: '#select-location-order-mobile',
    trigger: 'click',
    adjustTracker: true,
    closeOnClick: 'body',
    closeOnEsc: true,
    animation: 'move',
    isolateScroll: false,
    position: {
      x: 'center',
      y: 'top'
    },
    outside: 'x',
    offset: {
      x: -30,
      y: 44
    },
    onCreated: function () {
      $('#h-select-location .h-select-location-btn').off('click');
      $('#h-select-location .h-select-location-btn').on('click', function () {
        selectLocationOrderMobile.close();
      })
    },
    onOpen: () => {
      simpleBars.forEach((item) => {
        item.unMount();
      })

      simpleBars = [];

      setTimeout(() => {
        $('._custom-scroll').each((index, item) => {
          simpleBars.push(new SimpleBar(item, {
            autoHide: false
          }))
        })
      }, 200);
    }
  });

  if (selectLocationBasket !== null) {
    selectLocationBasket.destroy();
  }
  selectLocationBasket = new jBox('tooltip', {
    content: $('.header #h-select-location').clone(),
    attach: '#select-location-basket',
    trigger: 'click',
    adjustTracker: true,
    closeOnClick: 'body',
    closeOnEsc: true,
    animation: 'move',
    isolateScroll: false,
    position: {
      x: 'center',
      y: 'top'
    },
    outside: 'x',
    offset: {
      y: 44
    },
    onCreated: function () {
      $('#h-select-location .h-select-location-btn').off('click');
      $('#h-select-location .h-select-location-btn').on('click', function () {
        selectLocationBasket.close();
      })
    },
    onOpen: () => {
      simpleBars.forEach((item) => {
        item.unMount();
      })

      simpleBars = [];

      setTimeout(() => {
        $('._custom-scroll').each((index, item) => {
          simpleBars.push(new SimpleBar(item, {
            autoHide: false
          }))
        })
      }, 200);
    }
  });

  if (selectLocationBasketMobile !== null) {
    selectLocationBasketMobile.destroy();
  }
  selectLocationBasketMobile = new jBox('tooltip', {
    content: $('.header #h-select-location').clone(),
    attach: '#select-location-basket-mobile',
    trigger: 'click',
    adjustTracker: true,
    closeOnClick: 'body',
    closeOnEsc: true,
    animation: 'move',
    isolateScroll: false,
    position: {
      x: 'center',
      y: 'top'
    },
    outside: 'x',
    offset: {
      x: -30,
      y: 44
    },
    onCreated: function () {
      $('#h-select-location .h-select-location-btn').off('click');
      $('#h-select-location .h-select-location-btn').on('click', function () {
        selectLocationBasketMobile.close();
      })
    },
    onOpen: () => {
      simpleBars.forEach((item) => {
        item.unMount();
      })

      simpleBars = [];

      setTimeout(() => {
        $('._custom-scroll').each((index, item) => {
          simpleBars.push(new SimpleBar(item, {
            autoHide: false
          }))
        })
      }, 200);
    }
  });
};